@if (borrowerCreditScores) {
  <div class="d-flex flex-wrap flex-stack">
    <div class="d-flex flex-column flex-grow-1 pe-8">
      <div class="d-flex flex-wrap">
        <credit-score-indicator class="flex-fill" [useIcons]="useScoreIndicatorIcons" [companyName]="'Experian'" [score]="borrowerCreditScores.experian"></credit-score-indicator>
        <credit-score-indicator class="flex-fill" [useIcons]="useScoreIndicatorIcons" [companyName]="'Equifax'" [score]="borrowerCreditScores.equifax"></credit-score-indicator>
        <credit-score-indicator class="flex-fill" [useIcons]="useScoreIndicatorIcons" [companyName]="'Transunion'" [score]="borrowerCreditScores.transUnion"></credit-score-indicator>
      </div>
    </div>
  </div>
}
